import { CONST } from '@/utils/constants'
import { rowCountLimitErrorMessage } from '@/utils'
export const rowLimit = 200

export const actionWithinRowLimit = (rowCount) => {
  return rowCount <= rowLimit
}

export const validateReportTotal = (total) => {
  if (invalidRowCount(total)) {
    throwRowCountLimitError()
  }
}

export const invalidRowCount = (total) => {
  return total > CONST.Grid.PageSize
}
export const throwRowCountLimitError = () => {
  throw new Error(rowCountLimitErrorMessage())
}
export default {
  rowLimit,
  actionWithinRowLimit,
  invalidRowCount,
  throwRowCountLimitError,
  validateReportTotal
}
